module.exports = __webpack_public_path__ + "static/img/logo_49.2ab4aff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_49.png
// module id = zpdZ
// module chunks = 1